import Lookup from './lookup.js';

export default class Governorate extends Lookup
{
    
}
